import CacheHelper from "@/helper/CacheHelper";
export class LineQueryModel {
    constructor(){
        this.query = null,
        this.path = null,
        this.cacheKey = 'line_query'
    }
    setLineQuery(query){
        this.query = query
    }
    setLinePath(path){
        this.path = path
    }
    saveCache(){
        let data = {
            query: this.query,
            path: this.path
        }
        let cache = new CacheHelper("session");
        cache.setCache(this.cacheKey, data);
    }
    loadCache(){
        let cache = new CacheHelper("session");
        let cacheQueryLine = cache.getCache(this.cacheKey);
        if(cacheQueryLine != null){
            this.query = cacheQueryLine.query
            this.path = cacheQueryLine.path
        }
    }
}
